export type VoiceCapability = 'supported' | 'insecure' | 'unsupported-media' | 'unsupported-recognition';

export interface VoiceCapabilityEnvironment {
  isSecureContext: boolean;
  hasMediaDevices: boolean;
  hasMediaRecorder: boolean;
  hasSpeechRecognition: boolean;
}

export function detectVoiceCapability(environment: VoiceCapabilityEnvironment): VoiceCapability {
  if (!environment.isSecureContext) return 'insecure';
  if (!environment.hasMediaDevices || !environment.hasMediaRecorder) return 'unsupported-media';
  if (!environment.hasSpeechRecognition) return 'unsupported-recognition';
  return 'supported';
}

export function voiceCapabilityMessage(capability: VoiceCapability): string {
  if (capability === 'insecure') return 'Voice notes require a secure HTTPS page.';
  if (capability === 'unsupported-media') return 'This browser cannot record audio. Use a recent Chrome or Edge.';
  if (capability === 'unsupported-recognition') return 'This browser does not support speech transcription. Use text, files, or images instead.';
  return '';
}
